<template>
  <v-snackbar
    v-model="visible"
    v-bind="$attrs"
    location="top center"
    :color="color"
    :timeout="timeout"
    :max-width="maxWidth"
    :min-width="minWidth"
  >
    <div class="text-center">
      {{ message }}
    </div>
  </v-snackbar>
</template>

<script lang="ts" setup>
import { computed, ComputedRef } from "vue";
import { useDisplay } from "vuetify";

import { useSnackbar } from "@/stores/snackbar";

const snackbar = useSnackbar();

const display = useDisplay();

const visible: ComputedRef<boolean> = computed({
  get: () => snackbar.visible,
  set: () => {
    snackbar.hide();
  },
});

const message: ComputedRef<string> = computed(() => snackbar.message);

const color: ComputedRef<string> = computed(() => snackbar.color);

const timeout: ComputedRef<number> = computed(() => snackbar.timeout);

const maxWidth: ComputedRef<number> = computed(() => display.width.value - 32);

const minWidth: ComputedRef<number | undefined> = computed(() => {
  if (!display.mobile.value) return undefined;

  return display.width.value - 32;
});
</script>
